import React from 'react';
import { SCHOOL_FACILITIES } from '../../constants';
import SectionTitle from '../../components/SectionTitle';
import { Link } from "react-router-dom";

export default function FaciilitesSection() {
    return (
     
      <section className="section">
  <SectionTitle>School Facilities</SectionTitle>

  <div className="space-y-10 py-14">
    {SCHOOL_FACILITIES.map((facility, idx) => {
      const isEven = idx % 2 === 0;
      const image = facility.images[0]; // fallback to first image if others aren't available

      return (
        <div
          key={facility.id}
          className="grid grid-cols-1 md:grid-cols-2 rounded-xl shadow-md overflow-hidden"
        >
          {/* Text block */}
          <div
            className={`bg-primary text-white p-8 lg:p-16 flex flex-col justify-center ${
              isEven ? "order-1" : "order-2"
            }`}
          >
            <p className="uppercase mb-2">Facility</p>
            <h2 className="text-2xl font-semibold mb-4">{facility.title}</h2>
            <p className="font-normal mb-4 line-clamp-3">
              {facility.descriptions?.[0] || "No description available."}
            </p>
            <Link
              to={`/facilities/${facility.slug}/detail`}
              className="w-fit rounded bg-white px-4 py-2 text-primary hover:bg-gray-100"
            >
              Read More
            </Link>
          </div>

          {/* Image block */}
          <div
            className={`hidden md:block h-[300px] lg:h-[400px] ${
              isEven ? "order-2" : "order-1"
            }`}
          >
            <img
              src={image}
              alt={facility.title}
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      );
    })}
  </div>
</section>

    );
}
